import { SchemaField } from '@okletsplay/core';
import { DefaultDisplayValue } from 'app/enums';
import { GameSelectedSetting } from 'shared/interfaces';

type SettingsMeta = Record<string, SchemaField>;

export const prepareMatchSetupSettingsOptions = ({
  settings,
  meta,
}: {
  settings: Record<string, string | number>;
  meta: SettingsMeta;
}): GameSelectedSetting[] => {
  return Object.entries(settings ?? {})
    .map(([settingKey, settingValue]) => {
      const label = meta[settingKey]?.label || DefaultDisplayValue.NA;

      const enumFormat = meta[settingKey]?.visibilityConfig?.enumFormat;
      const value = enumFormat ? enumFormat[settingValue] : settingValue;

      const order =
        (meta[settingKey]?.visibilityConfig?.group ?? 0) +
        (meta[settingKey]?.visibilityConfig?.order ?? 0);

      return {
        label,
        value,
        order,
      };
    })
    .sort(({ order }) => order)
    .map(({ label, value }) => ({ label, value }));
};
